import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="protected-loading">
        <div className="mono text-xs uppercase tracking-widest text-[color:var(--ink-2)]">Authenticating…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="min-h-screen flex items-center justify-center flex-col gap-2" data-testid="forbidden">
        <div className="serif text-4xl">403</div>
        <div className="text-sm text-[color:var(--ink-2)]">You do not have access to this area.</div>
      </div>
    );
  }
  return children;
}
